/**
 * TanStack Query hooks for `goal-reports`. Thin wrappers over ./api.
 *
 * Filter args are part of the query key so distinct filter combinations are
 * cached independently and cross-filter transitions get instant re-renders
 * from cache when possible.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	listGoalReports,
	goalReportsQueryKeys,
	type GoalReportsQueryArgs,
	type GoalReportsResponse,
} from "./api";

export function useGoalReportsQuery(
	args: GoalReportsQueryArgs,
): UseQueryResult<GoalReportsResponse, Error> {
	return useQuery({
		queryKey: goalReportsQueryKeys.list(args),
		queryFn: () => listGoalReports(args),
	});
}
